<template>
  <div class="row">
    <div class="col-12">
      <filter-component />
      <table-component />
    </div>
  </div>
</template>

<script>
  import TableComponent from '@pbx/components/contacts/list/table';
  import FilterComponent from '@pbx/components/contacts/list/filter';

  export default {
    components: {
      TableComponent,
      FilterComponent
    }
  };
</script>
